(function () {
  var MOBILE_MQ = window.matchMedia('(max-width: 767px)');

  function getMaxScroll(scrollEl) {
    return Math.max(0, scrollEl.scrollWidth - scrollEl.clientWidth);
  }

  function initHorizontalScrollProgress() {
    if (!MOBILE_MQ.matches) return;

    document.querySelectorAll('[data-b2b-horizontal-scroll]').forEach(function (scrollEl) {
      var group = scrollEl.closest('[data-b2b-scroll-group]') || scrollEl.parentElement;
      var progress = group && group.querySelector('.b2b-scroll-progress');
      var fill = group && group.querySelector('[data-b2b-scroll-progress-fill]');

      function updateScrollState() {
        if (!MOBILE_MQ.matches) {
          if (progress) progress.classList.remove('is-visible');
          return;
        }

        var maxScroll = getMaxScroll(scrollEl);
        var isScrollable = maxScroll > 1;

        if (progress) {
          progress.classList.toggle('is-visible', isScrollable);
        }

        if (fill) {
          if (!isScrollable) {
            fill.style.width = '23%';
          } else {
            var scrolled = scrollEl.scrollLeft / maxScroll;
            fill.style.width = 23 + scrolled * 77 + '%';
          }
        }
      }

      if (!scrollEl.dataset.b2bScrollProgressBound) {
        scrollEl.dataset.b2bScrollProgressBound = 'true';
        scrollEl.addEventListener('scroll', updateScrollState, { passive: true });
        window.addEventListener('resize', updateScrollState, { passive: true });
        window.addEventListener('load', updateScrollState, { passive: true });

        if (typeof ResizeObserver !== 'undefined') {
          var ro = new ResizeObserver(updateScrollState);
          ro.observe(scrollEl);
          if (scrollEl.firstElementChild) ro.observe(scrollEl.firstElementChild);
        }
      }

      updateScrollState();
      window.requestAnimationFrame(updateScrollState);
    });
  }

  function onMobileChange() {
    initHorizontalScrollProgress();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHorizontalScrollProgress);
  } else {
    initHorizontalScrollProgress();
  }

  document.addEventListener('shopify:section:load', initHorizontalScrollProgress);

  if (typeof MOBILE_MQ.addEventListener === 'function') {
    MOBILE_MQ.addEventListener('change', onMobileChange);
  } else if (typeof MOBILE_MQ.addListener === 'function') {
    MOBILE_MQ.addListener(onMobileChange);
  }
})();
